export const REAL_LEAGUE_TEAMS = 'REAL_LEAGUE_TEAMS';
export const REAL_LEAGUES = 'REAL_LEAGUES';
export const PRIVATE_LEAGUE_DETAILS = 'PRIVATE_LEAGUE_DETAILS';
export const PRIVATE_LEAGUES = 'PRIVATE_LEAGUES';
export const PRIVATE_LEAGUE = 'PRIVATE_LEAGUE';
export const AD = 'AD';
export const STANDINGS = 'STANDINGS';
